import { Component } from '@theme/component';

/**
 * Size Chart Modal Component
 * Handles opening and closing the size chart modal
 */
class SizeChartModal extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.init();
  }

  init() {
    // Listen for size chart open events
    document.addEventListener('size-chart:open', this.openModal.bind(this));

    // Close on escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.getAttribute('aria-hidden') === 'false') {
        this.closeModal();
      }
    });

    // Direct event listeners for close button and backdrop (fallback for on:click)
    const closeBtn = this.querySelector('.tn-size-guide-modal__close');
    const backdrop = this.querySelector('.tn-size-guide-modal__backdrop');

    if (closeBtn) {
      closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.closeModal();
      });
    }

    if (backdrop) {
      backdrop.addEventListener('click', (e) => {
        e.preventDefault();
        this.closeModal();
      });
    }

    // Prevent body scroll when modal is open
    this.addEventListener('transitionend', () => {
      if (this.getAttribute('aria-hidden') === 'false') {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    });
  }

  openModal() {
    this.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    // Focus the modal for accessibility
    this.focus();
  }

  closeModal() {
    this.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
}

// Register custom element
if (!customElements.get('size-chart-modal')) {
  customElements.define('size-chart-modal', SizeChartModal);
}

export { SizeChartModal };
